import clsx from 'clsx'

interface ButtonDownloadProps extends React.HTMLAttributes<HTMLParagraphElement> {
  fileUrl?: string
  className?: string
  text?: string
  disabled?: boolean
}

const ButtonDownload = ({
  fileUrl = '/example.csv',
  className = 'download-link',
  text = 'Example CSV file',
  disabled = false,
  ...restProps
}: ButtonDownloadProps) => {
  function getFileName(path: string): string {
    if (!path) return ''
    const parts = path.split('/').filter(Boolean) // Lọc bỏ chuỗi rỗng
    return parts[parts.length - 1] || ''
  }

  const handleDownload = (e: any) => {
    e.preventDefault()
    if (disabled) return
    const link = document.createElement('a')
    link.href = fileUrl
    link.download = getFileName(fileUrl)

    // Append the link to the document and trigger the download
    document.body.appendChild(link)
    link.click()

    // Clean up the DOM by removing the link
    document.body.removeChild(link)
  }

  return (
    <p className={clsx(className)} onClick={handleDownload} {...restProps}>
      {text}
    </p>
  )
}

export default ButtonDownload
